import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const VideoRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.video_create === true ||
    permissions.video_edit === true ||
    permissions.video_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default VideoRouteMiddleware;
